/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { FormattedMessage } from "react-intl";
import { useUserContext } from "../../../contexts/userContext";
import { roles } from '../../../constants/appConstants';

/* Components */
import { ReactComponent as PlaneIcon } from "../../../resources/images/choice-plane.svg"
import { ReactComponent as ClipboardIconChoice } from "../../../resources/images/choice-policy-active.svg"

/* Styles */
import styles from "./styles.js"


const Content = ({ userRole, setUserRole, roleOptions }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const userContext = useUserContext();
  const providerCode = userContext?.userInfo?.providerInfo?.providerCode;
  const options = roleOptions ?? [];
  return (
    <div className={classes.modalContent}>
      {options.map(({ optionValue, optionText }) => (
        <div
          key={optionValue}
          className={
            userRole === optionValue
              ? `${classes.optionContainer} ${classes.selectedOptionContainer}`
              : classes.optionContainer
          }
          onClick={() => setUserRole(optionValue)}
        >
          <div className={classes.logo}>
            {optionValue === roles.travelerRole ? (
              <PlaneIcon className={classes.icon} />
            ) : (
              <ClipboardIconChoice className={classes.icon} />
            )}
          </div>
          <div className={classes.textContainer}>
            <h3>
              <FormattedMessage
                id={`peopleGrid.updateTeamAction.roleName.${optionValue}.${providerCode}`}
              />
            </h3>
            <p>
              <FormattedMessage
                id={`peopleGrid.updateTeamAction.roleDescription.${optionValue}.${providerCode}`}
              />
            </p>
          </div>
          <div>
            <input
              onChange={() => setUserRole(optionValue)}
              type="radio"
              name={optionValue}
              id={optionValue}
              checked={userRole === optionValue}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Content;
